import type { AuthCredentials, AuthLoginResponse } from '@/types/auth.types.ts'
import { CLEVERLINK_API_BASE_URL } from '@/constants/apiConstants.ts'

export const authRoutes = {
  root: `${CLEVERLINK_API_BASE_URL}/auth`,
  login() {
    return `${authRoutes.root}/login`
  },
}

export const passwordResetRoutes = {
  request() {
    return `${authRoutes.root}/password-reset/request`
  },
  confirm() {
    return `${authRoutes.root}/password-reset/confirm`
  },
}

export const loginUser = async (
  credentials: AuthCredentials,
): Promise<AuthLoginResponse> => {
  const url = new URL(authRoutes.login(), window.location.origin)

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  })

  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `Login failed: ${response.status}`)
  }

  return response.json()
}

export const requestPasswordReset = async (
  email: string,
): Promise<{ message: string }> => {
  const url = new URL(passwordResetRoutes.request(), window.location.origin)

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `Password reset request failed: ${response.status}`)
  }

  return response.json()
}

export const confirmPasswordReset = async (
  token: string,
  password: string,
): Promise<{ message: string }> => {
  const url = new URL(passwordResetRoutes.confirm(), window.location.origin)

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  })

  if (!response.ok) {
    const text = await response.text()
    const error = new Error(
      text || `Password reset confirm failed: ${response.status}`,
    ) as Error & { status: number }
    error.status = response.status
    throw error
  }

  return response.json()
}
